import React from 'react';
import { Box, Typography } from '@mui/material';

import { ReactComponent as IsleIcon } from '../../../../assets/clan/clanTrophies/icons/isle_icon.svg';
import { ReactComponent as CupIcon } from '../../../../assets/clan/clanTrophies/icons/cup_icon.svg';
import { ReactComponent as WlknIcon } from '../../../../assets/clan/clanTrophies/icons/wlkn_icon.svg';

const Medal = ({
    bgColor,
    medalSvg: MedalSvg,
    text,
    medals,
}: {
    bgColor: string;
    medalSvg: React.FunctionComponent;
    text: string;
    medals: {
        isle: number | undefined;
        cup: number | undefined;
        wlkn: number | undefined;
    };
}) => {
    return (
        <Box width={'100%'}>
            <Box
                sx={{
                    height: '231px',
                    backgroundColor: bgColor + '10',
                    borderRadius: '20px',
                }}
            >
                <Box
                    sx={{
                        padding: '20px',
                        textAlign: 'center',
                    }}
                >
                    <MedalSvg></MedalSvg>
                    <Typography
                        sx={{
                            color: '#0F0E0E40',
                            fontFamily: 'AvenirNext400',
                            fontSize: '14px',
                            marginTop: '10px',
                        }}
                    >
                        {text}
                    </Typography>
                    <Typography
                        sx={{
                            color: '#0F0E0E',
                            fontFamily: 'AvenirNext700',
                            fontSize: '24px',
                            marginBottom: '5px',
                        }}
                    >
                        {medals.isle !== undefined && medals.cup !== undefined && medals.wlkn !== undefined
                            ? medals.isle + medals.cup + medals.wlkn
                            : 0}
                    </Typography>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            gap: '10px',
                        }}
                    >
                        <Box
                            sx={{
                                width: '100%',
                                border: `1px solid ${bgColor + 25}`,
                                borderRadius: '10px',
                                paddingTop: '15px',
                            }}
                        >
                            <IsleIcon></IsleIcon>
                            <Typography
                                sx={{
                                    color: '#0F0E0E',
                                    fontFamily: 'AvenirNext500',
                                    fontSize: '16px',
                                    marginBottom: '10px',
                                }}
                            >
                                {medals.isle ?? 0}
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                width: '100%',
                                border: `1px solid ${bgColor + 25}`,
                                borderRadius: '10px',
                                paddingTop: '15px',
                            }}
                        >
                            <CupIcon></CupIcon>
                            <Typography
                                sx={{
                                    color: '#0F0E0E',
                                    fontFamily: 'AvenirNext500',
                                    fontSize: '16px',
                                    marginBottom: '10px',
                                }}
                            >
                                {medals.cup ?? 0}
                            </Typography>
                        </Box>

                        <Box
                            sx={{
                                width: '100%',
                                border: `1px solid ${bgColor + 25}`,
                                borderRadius: '10px',
                                paddingTop: '15px',
                            }}
                        >
                            <WlknIcon></WlknIcon>
                            <Typography
                                sx={{
                                    color: '#0F0E0E',
                                    fontFamily: 'AvenirNext500',
                                    fontSize: '16px',
                                    marginBottom: '10px',
                                }}
                            >
                                {medals.wlkn ?? 0}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};
export default Medal;
